import React from 'react';
import { FadeIn } from './FadeIn';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Llevaba 8 meses corriendo y siempre terminaba igual. En 3 semanas con el sistema entendí por qué no progresaba. Ahora bajo tiempos cada semana.',
    author: 'Martín G.',
    location: 'Corredor amateur · Buenos Aires',
    initial: 'M'
  }, {
    quote: 'Me dolía la tibia hace meses y pensé que era normal. El Tomo 1 me hizo entender que estaba corriendo con una lesión activa. Paré, apliqué el protocolo y volví sin dolor.',
    author: 'Carolina R.',
    location: 'Corredora de ruta · Córdoba',
    initial: 'C'
  }, {
    quote: 'Siempre corrí por intuición. Nunca supe si hacía bien o mal. Este sistema me dio por primera vez un plan que entiendo y que puedo seguir solo.',
    author: 'Diego F.',
    location: 'Corredor amateur · Rosario',
    initial: 'D'
  }, {
    quote: 'El Tomo 3 de biomecánica me cambió la forma de correr en una semana. No exagero.',
    author: 'Lucía M.',
    location: 'Corredora de ruta y trail · Mendoza',
    initial: 'L'
  }, {
    quote: 'Probé 3 planes de internet antes de este. Ninguno me funcionó porque ninguno tenía un mecanismo real. El PCS hace toda la diferencia.',
    author: 'Andrés P.',
    location: 'Corredor trail · Salta',
    initial: 'A'
  }, {
    quote: 'Las rutinas de fuerza del Tomo 5 me sacaron el dolor de rodilla que tenía hace un año. 15 minutos dos veces por semana. Increíble.',
    author: 'Facundo R.',
    location: 'Corredor de ruta · Santa Fe',
    initial: 'F'
  }];
  const Stars = () => <div className="flex gap-1 md:gap-1.5 text-[#22c55e] mb-3 md:mb-6" data-id="element-348">
      {[...Array(5)].map((_, i) => <Star key={i} fill="currentColor" className="drop-shadow-[0_0_5px_rgba(34,197,94,0.3)] w-4 h-4 md:w-5 md:h-5" data-id="element-349" />)}
    </div>;
  return <section className="py-8 md:py-20 px-4 max-w-6xl mx-auto bg-[#f8fafc]" data-id="element-350">
      <FadeIn data-id="element-351">
        <h2 className="text-2xl md:text-5xl font-black text-[#0f172a] text-center mb-6 md:mb-14 flex items-center justify-center gap-2 md:gap-4 px-2" data-id="element-352">
          <span className="text-[#ef4444] drop-shadow-[0_0_15px_rgba(239,68,68,0.2)]" data-id="element-353">
            ❤️
          </span>{' '}
          LO QUE DICEN LOS QUE YA LO TIENEN
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8" data-id="element-354">
        {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-355">
            <motion.div whileHover={{
          y: -5
        }} className="bg-white border border-[#e2e8f0] hover:border-[#22c55e]/50 rounded-2xl md:rounded-3xl p-5 md:p-8 h-full relative overflow-hidden shadow-sm hover:shadow-md transition-all" data-id="element-356">
              <Quote className="absolute top-4 right-4 md:top-6 md:right-6 text-[#f1f5f9] w-16 h-16 md:w-24 md:h-24 rotate-180 -z-0" data-id="element-357" />

              <div className="relative z-10 flex flex-col h-full" data-id="element-358">
                <Stars data-id="element-359" />
                <p className="text-base md:text-xl text-[#0f172a] mb-4 md:mb-8 italic leading-relaxed font-medium flex-grow" data-id="element-360">
                  "{t.quote}"
                </p>
                <div className="flex items-center gap-3 md:gap-4 mt-auto pt-4 md:pt-6 border-t border-[#e2e8f0]" data-id="element-361">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-[#22c55e] to-[#4ade80] rounded-full flex items-center justify-center text-[#020617] font-black text-base md:text-xl shadow-[0_5px_15px_rgba(34,197,94,0.3)]" data-id="element-362">
                    {t.initial}
                  </div>
                  <div data-id="element-363">
                    <p className="font-black text-[#0f172a] text-base md:text-lg" data-id="element-364">
                      {t.author}
                    </p>
                    <p className="text-xs md:text-sm text-[#475569] font-bold" data-id="element-365">
                      {t.location}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </FadeIn>)}
      </div>
    </section>;
}